/** @format */

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_STORE_URLS } from "../utils/constants";
import { trackEvent, EventNames } from "../utils/analytics";

const Download: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const detectDeviceAndRedirect = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isIOS = /ipad|iphone|ipod/.test(userAgent);
      const isAndroid = /android/.test(userAgent);
      const isMobile = isIOS || isAndroid;

      // Track the download page visit
      trackEvent(EventNames.PAGE_VIEW, {
        page_name: "download_redirect",
        user_agent: userAgent,
        is_mobile: isMobile,
        device_type: isIOS ? "ios" : isAndroid ? "android" : "desktop",
      });

      if (isIOS) {
        // Redirect to App Store for iOS devices
        trackEvent(EventNames.BUTTON_CLICK, {
          button_name: "Auto Redirect - App Store",
          button_location: "download_page",
          store_type: "apple_app_store",
          destination_url: APP_STORE_URLS.APPLE_APP_STORE,
        });
        window.location.href = APP_STORE_URLS.APPLE_APP_STORE;
      } else if (isAndroid) {
        // Redirect to Google Play for Android devices
        trackEvent(EventNames.BUTTON_CLICK, {
          button_name: "Auto Redirect - Google Play",
          button_location: "download_page",
          store_type: "google_play_store",
          destination_url: APP_STORE_URLS.GOOGLE_PLAY_STORE,
        });
        window.location.href = APP_STORE_URLS.GOOGLE_PLAY_STORE;
      } else {
        // For desktop users, redirect to home page
        trackEvent(EventNames.NAVIGATION_CLICK, {
          from_page: "download_page",
          to_page: "home",
          reason: "desktop_redirect",
        });
        navigate("/");
      }
    };

    // Small delay to ensure tracking is properly initialized
    const timeout = setTimeout(detectDeviceAndRedirect, 100);

    return () => clearTimeout(timeout);
  }, [navigate]);

  // Show a brief loading message while redirecting
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#1a1a1a",
        color: "#ffffff",
        fontFamily: "Poppins, Arial, sans-serif",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h2>Redirecting to download...</h2>
        <p>Please wait while we redirect you to the appropriate store.</p>
      </div>
    </div>
  );
};

export default Download;
